/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

const SEARCH_FIELDS = ["etiqueta"];

export default function Laboratorios() {
  const [loader, setLoader] = useState(true);
  const [laboratorios, setLaboratorios] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearLaboratorio(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/laboratorio",
      camposFormulario,
      (respuesta) => {
        navigate(`/proveedores/laboratorios/${respuesta[0].id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear laboratorio",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        nombre: "Datos del laboratorio",
        campos: [
          {
            nombre: "razonsocial",
            tipoitemformularioid: 1,
            etiqueta: "Razón social",
            requerido: true
          },
          {
            nombre: "nombrefantasia",
            tipoitemformularioid: 1,
            etiqueta: "Nombre fantasía"
          },
          {
            nombre: "rut",
            tipoitemformularioid: 1,
            etiqueta: "RUT"
          },
          {
            nombre: "direccion",
            tipoitemformularioid: 1,
            etiqueta: "Direccion",
            requerido: true
          },
          {
            nombre: "codigopostal",
            tipoitemformularioid: 1,
            etiqueta: "Código postal",
            requerido: true
          },
          {
            nombre: "ciudad",
            tipoitemformularioid: 1,
            etiqueta: "Ciudad",
            requerido: true,
            respuesta: "Montevideo"
          },
          {
            nombre: "estado",
            tipoitemformularioid: 1,
            etiqueta: "Estado",
            requerido: true,
            respuesta: "Montevideo"
          },
          {
            nombre: "pais",
            tipoitemformularioid: 1,
            etiqueta: "País",
            requerido: true,
            respuesta: "Uruguay"
          },
          {
            nombre: "telefono",
            tipoitemformularioid: 1,
            etiqueta: "Teléfono"
          },
          {
            nombre: "email",
            tipoitemformularioid: 2,
            etiqueta: "Email"
          },
          {
            nombre: "pagina",
            tipoitemformularioid: 1,
            etiqueta: "Página"
          },
          {
            nombre: "esCalibracion",
            tipoitemformularioid: 6,
            etiqueta: "Es laboratorio de calibración"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear laboratorio",
        callback: crearLaboratorio,
        validar: true
      }
    ]
  };

  useEffect(() => {
    document.title = "Laboratorios";
    accessAPI(
      "GET",
      "admin/laboratorio",
      null,
      (respuesta) => {
        setLaboratorios(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar laboratorios",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo laboratorio</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <Skeleton width="15rem" height="2.5rem" />
            <Skeleton width="12rem" height="2.5rem" />
          </div>
          <Card>
            <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            botones={
              <Boton callback={() => setSideBar(true)}>Nuevo laboratorio</Boton>
            }
          >
            Laboratorios
          </Titulo>

          <Card>
            <TablaFiltrable
              value={laboratorios}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="laboratorios"
              emptyMessage="No hay laboratorios registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(`/proveedores/laboratorios/${e.data.value}`, "_blank");
                } else {
                  navigate(`/proveedores/laboratorios/${e.data.value}`);
                }
              }}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Nombre" field="etiqueta" />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
